import { Form, Input, Modal, Image, Row, Col, message, Divider, Spin, Button } from 'antd';
import { useEffect, useState } from 'react';
import { getProductById } from '../../Services/Product.service';

const ProductDetailModal = ({ onCancel, open, itemId, ...props }: any) => {
  const { TextArea } = Input;
  const [form] = Form.useForm();
  const [disableForm, setDisableForm] = useState(false);
  const [productDetail, setProductDetail] = useState<any>();
  const [, setImages] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isDisplaySale, setIsDisplaySale] = useState(false);

  useEffect(() => {
    if (open) {
      getProductDetail();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemId]);

  useEffect(() => {
    if (productDetail === undefined) {
      return;
    }
    form.setFieldsValue({
      item_name: productDetail.item_name,
      item_size: productDetail.item_size,
      item_price: productDetail.item_price + ' บาท',
      item_acc: productDetail.item_acc,
      item_age: productDetail.item_age + ' เดือน',
      item_barcode: productDetail.item_barcode,
      item_component: productDetail.item_component,
      item_memo: productDetail.item_memo,
      item_method: productDetail.item_method1 + productDetail.item_method2,
      item_recommend: productDetail.item_recommend,
      item_warning: productDetail.item_warning,
      item_image: productDetail.item_image,
      item_is_sale_desc: productDetail.item_is_sale ? '' : 'สินค้างดจำหน่าย',
      product_image: productDetail.product_image[0],
    });

    setIsDisplaySale(productDetail.item_is_sale);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productDetail]);

  const getProductDetail = async () => {
    setIsLoading(true);
    const res = await getProductById(itemId);
    if (res.res_code === '000') {
      setIsLoading(false);
    } else if (res.res_code === 'E101') {
      message.error('ไม่พบข้อมูลสินค้า');
    } else {
      message.error('ไม่พบข้อมูลสินค้า');
    }

    setProductDetail(res.datas);
    setImages(res.datas.item_image[0]);
    setDisableForm(true);
  };
  const layout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 20 },
  };
  const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 20 },
  };
  return (
    <div {...props}>
      <Modal
        title="รายละเอียด"
        centered
        open={open}
        onCancel={onCancel}
        footer={[
          <Button key="back" onClick={onCancel} type="default">
            ปิด
          </Button>,
        ]}
        width={1200}
      >
        <Divider />
        <Spin spinning={isLoading}>
          <Form form={form} {...formItemLayout} layout="horizontal" disabled={disableForm}>
            {/* Input Section */}
            <Row gutter={8} align="middle">
              <Col span={16}>
                <Row gutter={8}>
                  <Col span={12}>
                    <Form.Item label="ชื่อยา" name="item_name">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="ขนาด" name="item_size">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="บัญชียา" name="item_acc">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="อายุสินค้า" name="item_age">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="ราคา" name="item_price">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="รหัส Barcode" name="item_barcode">
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>

              {/* Image Section */}
              <Col
                span={8}
                style={{
                  textAlign: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <Form.Item name="item_is_sale_desc" hidden={isDisplaySale}>
                  <Input
                    style={{
                      textAlign: 'center',
                    }}
                  />
                </Form.Item>
                <Image
                  src={productDetail?.product_image[0]}
                  style={{
                    maxWidth: '200px',
                    maxHeight: '200px',
                    objectFit: 'contain',
                  }}
                />
              </Col>
            </Row>

            {/* TextArea Section */}
            {[
              { label: 'ส่วนประกอบ', name: 'item_component' },
              { label: 'ข้อบ่งใช้', name: 'item_memo' },
              { label: 'วิธีใช้', name: 'item_method' },
              { label: 'คำแนะนำ', name: 'item_recommend' },
              { label: 'คำเตือน', name: 'item_warning' },
            ].map((field, index) => (
              <Row key={index} gutter={8} align="middle">
                <Col span={16} {...layout}>
                  <Form.Item label={field.label} name={field.name}>
                    <TextArea rows={2} />
                  </Form.Item>
                </Col>
              </Row>
            ))}
          </Form>
        </Spin>
      </Modal>
    </div>
  );
};

export default ProductDetailModal;
